"use client";

import React, { createContext, useContext, useState } from "react";

interface WalletSelectionContextType {
	selectedWalletAddress: string | null;
	setSelectedWalletAddress: (address: string | null) => void;
}

const WalletSelectionContext = createContext<WalletSelectionContextType>({
	selectedWalletAddress: null,
	setSelectedWalletAddress: () => {},
});

export function WalletSelectionProvider({
	children,
}: {
	children: React.ReactNode;
}) {
	const [selectedWalletAddress, setSelectedWalletAddress] = useState<
		string | null
	>(null);

	return (
		<WalletSelectionContext.Provider
			value={{ selectedWalletAddress, setSelectedWalletAddress }}
		>
			{children}
		</WalletSelectionContext.Provider>
	);
}

/**
 * Returns the shared wallet selection state.
 * All instances of usePrivyWallet across the app share the same
 * selectedWalletAddress so that switching from WalletSwitcher propagates
 * immediately to every consumer (header, wallet page, etc.).
 */
export function useWalletSelection(): WalletSelectionContextType {
	return useContext(WalletSelectionContext);
}
